import { useDragLayer } from 'react-dnd';
import styled from 'foundations-theming/utils';
import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { Text } from 'foundations-components/components/Text';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "CustomDragLayer__StyledWrapper"
})(["position:fixed;pointer-events:none;z-index:100;left:0;top:0;width:100%;height:100%;"]);
const StyledMoveableObjectWrapper = styled.div.attrs(({
  clientOffset
}) => ({
  style: clientOffset ? {
    transform: `translate(${clientOffset.x}px, ${clientOffset.y}px)`
  } : undefined
})).withConfig({
  displayName: "CustomDragLayer__StyledMoveableObjectWrapper"
})(["width:300px;transition:none;display:", ";"], ({
  clientOffset
}) => clientOffset ? 'block' : 'none');
const DragLabel = ({
  item = {},
  isFormLabelPropertyEnabled
}) => {
  const label = item.formFieldLabel || item.propertyLabel || item.label || '';
  const name = item.formFieldName || item.propertyName || item.name;
  const isEnabled = isFormLabelPropertyEnabled || item.isFormLabelPropertyEnabled;
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("span", {
      children: sanitize(label, config.TEXTONLY)
    }), isEnabled && /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: name
    })]
  });
};
const isUnsupportedBrowser = () => {
  const userAgent = window.navigator.userAgent;
  return userAgent.indexOf('Edge/') !== -1 || userAgent.indexOf('Trident/') !== -1 || userAgent.indexOf('MSIE ') !== -1;
};
const CustomDragLayer = ({
  isFormLabelPropertyEnabled
}) => {
  const isUnsupported = isUnsupportedBrowser();
  const {
    isDragging,
    clientOffset,
    item
  } = useDragLayer(monitor => ({
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
    item: monitor.getItem() || {}
  }));
  if (!isDragging || isUnsupported || item.isCreateNewField) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledWrapper, {
    children: /*#__PURE__*/_jsx(StyledMoveableObjectWrapper, {
      clientOffset: clientOffset,
      children: /*#__PURE__*/_jsx(MoveableObject, {
        closeable: false,
        draggable: true,
        isDragging: isDragging,
        children: /*#__PURE__*/_jsx(DragLabel, {
          item: item,
          isFormLabelPropertyEnabled: isFormLabelPropertyEnabled
        })
      })
    })
  });
};
export default CustomDragLayer;